import React, { FC, useState } from 'react';
import ProductDetailsModal from '../ProductDetailsModal/ProductDetailsModal';
import Row from '../ResponsiveRow';
import FalconDescription from '../FalconDescription/FalconDescription';
import FalconAccordionList from '../FalconAccordionList/FalconAccordionList';
import Spacer from '../Spacer/Spacer';
import { FALCONDESCRIPTION, FALCONDESCRIPTIONLIST, SPACER } from '../../utils/constants';
import './ProductDetails.css';
import StaticPriceComp from '../StaticPriceComp/StaticPriceComp';

interface ProductDetailsSchema {
  content: any;
  updatedContent: any;
  modalTriggered?: () => void;
  addToCart?: (e: string) => void;
}

const ProductDetails: FC<ProductDetailsSchema> = ({
  content,
  updatedContent,
  modalTriggered,
  addToCart
}) => {
  const [modalState, setModalState] = useState(false);
  const products = content?.subscriptionDetailModal;
  let falconBody: any = [],
    prodVariant = '',
    backBtn = '',
    priceNotification: any = [];

  products &&
    products?.length > 0 &&
    products?.map((e: any) => {
      falconBody = e?.modalBody;
      prodVariant = e?.productPriceVariant ?? '';
      backBtn = e?.backButton;
      priceNotification = e?.priceChangeContent;
    });

  const handleClick = () => {
    setModalState(!modalState);
    if (typeof modalTriggered == 'function') modalTriggered();
  };

  return (
    <>
      {modalState && (
        <ProductDetailsModal
          modalState={modalState}
          handler={handleClick}
          showFooter={false}
          height={'100%'}
          width={'883px'}
          backButton={backBtn}
        >
          <>
            {falconBody?.map((ele: any, index: number) => (
              <Row>
                <>
                  {ele?.component === FALCONDESCRIPTION && (
                    <FalconDescription content={ele} key={index} />
                  )}
                  {ele?.component === SPACER && <Spacer content={ele} />}
                  {ele?.component === FALCONDESCRIPTIONLIST && (
                    <FalconAccordionList content={ele} />
                  )}
                </>
              </Row>
            ))}
            {content?.isEnablePrice && (
              <StaticPriceComp content={content} addToCart={addToCart} variant='productDetails' />
            )}
          </>
        </ProductDetailsModal>
      )}
      <span onClick={handleClick} className='linetable-productDetailsText'>
        {updatedContent?.subscription ?? updatedContent?.subscriptionText}
      </span>
    </>
  );
};

export default ProductDetails;
